import ListItemIssues from "../../../../components/@documents/item_issues/ListItemIssues";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemIssuesPage() {

    return (
        <ListItemIssues 
            routeType={routeTypes.admin}
        />
    )
}